import { Button } from '@/components/ui/button';
import { Loader2 } from '@/components/ui/icons';

interface AdminSectionProps {
  bumpThumbnails: () => void;
  isBumping: boolean;
}

export function AdminSection({ bumpThumbnails, isBumping }: AdminSectionProps) {
  return (
    <section className="rounded-xl border border-telekinesis-neutral-800 bg-telekinesis-background-2 p-6">
      <h2 className="mb-5 text-sm font-medium text-telekinesis-neutral-50">
        Admin
      </h2>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div className="text-sm text-telekinesis-neutral-50">
            Regenerate all thumbnails
          </div>
          <div className="mt-0.5 text-xs leading-relaxed text-telekinesis-neutral-200">
            Bumps the thumbnail version so every user's browser discards
            cached card images and re-renders them. Run after graphics
            updates.
          </div>
        </div>
        <Button
          className="flex-shrink-0 rounded-full font-light"
          onClick={() => bumpThumbnails()}
          disabled={isBumping}
        >
          {isBumping ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          ) : null}
          Regenerate
        </Button>
      </div>
    </section>
  );
}
